/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateAADOauthKeyInput = {
    email?: string | null | undefined;
    issuer?: string | null | undefined;
    mobileAppUrl?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type createAADOauthKeyMutationVariables = {
    input: CreateAADOauthKeyInput;
};
export type createAADOauthKeyMutationResponse = {
    readonly createAADOauthKey: {
        readonly key: string | null;
        readonly AADClientId: string | null;
        readonly AADTenant: string | null;
    } | null;
};
export type createAADOauthKeyMutation = {
    readonly response: createAADOauthKeyMutationResponse;
    readonly variables: createAADOauthKeyMutationVariables;
};



/*
mutation createAADOauthKeyMutation(
  $input: CreateAADOauthKeyInput!
) {
  createAADOauthKey(input: $input) {
    key
    AADClientId
    AADTenant
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateAADOauthKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAADOauthKeyPayload",
    "kind": "LinkedField",
    "name": "createAADOauthKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "AADClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "AADTenant",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createAADOauthKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createAADOauthKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createAADOauthKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createAADOauthKeyMutation(\n  $input: CreateAADOauthKeyInput!\n) {\n  createAADOauthKey(input: $input) {\n    key\n    AADClientId\n    AADTenant\n  }\n}\n"
  }
};
})();
(node as any).hash = '568b9266eafbce3d9d29e3634a15b9fb';
export default node;
